import React,{useEffect, useRef } from 'react'
import gsap from 'gsap';

// import feed1 from "../../../assets/feed_screenshot/01.png"
// import feed2 from "../../../assets/feed_screenshot/02.png"
// import feed3 from "../../../assets/feed_screenshot/03.png"
// import feed4 from "../../../assets/feed_screenshot/04.png"
// import feed5 from "../../../assets/feed_screenshot/05.png"

const images =["../../../assets/feed_screenshot/04.png", "../../../assets/feed_screenshot/04.png"]  //[feed1, feed2, feed3, feed4, feed5]

const InfiniteScroll = () => {
  const sliderRef = useRef(null);
  const cardsContainerRef = useRef(null);

  useEffect(() => {
    if (!cardsContainerRef.current) return;

    // Clone cards for seamless loop
    const originalCards = cardsContainerRef.current.children;
    const totalCards = originalCards.length;

    // Clone cards and append them to create seamless loop
    [...originalCards].forEach((card) => {
        const clone = card.cloneNode(true);
        cardsContainerRef.current?.appendChild(clone);
    });

    // Calculate total height
    const cardHeight = originalCards[0].getBoundingClientRect().height;
    const totalHeight = cardHeight * totalCards;

    // Create infinite loop animation
    gsap.to(cardsContainerRef.current, {
        y: -totalHeight,
        duration: 20,
        ease: "none",
        repeat: -1,
        onRepeat: () => {
            gsap.set(cardsContainerRef.current, { y: 0 });
        },
    });

    return () => {
        gsap.killTweensOf(cardsContainerRef);
    };
}, []);

  
  return (
    <div className='relative w-full h-[75vh]'>
      <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b rounded-lg from-white/10 to-transparent z-10" />

        <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t rounded-lg from-white/10 to-transparent z-10" />
        
        <div ref={sliderRef} className='relative overflow-hidden h-full w-full px-4'>
          <div ref={cardsContainerRef} className='w-full flex flex-col'>
            {images.map((item, idx) => (
                <div key={idx} className='bg-gray-300 my-5  h-[250px] w-full z-10'>
                  <img src={item} alt="feed" className='h-full w-full' />
                </div>
            ))}
          </div>
        </div>
    </div>
  )
}

export default InfiniteScroll